import { status } from 'skin/event/status';
import { message } from 'skin/event';

const add = (obj) => {
	message('Удаление не активно', 'О приложении', null, '!');
	return status.ignore
};

export default add;
